<template>
  <div class="login-page page-container">
    <div class="login-dialog">
      <div class="dialog-title">扫码付费阅读：3元/篇</div>
      <!-- 添加二维码显示逻辑 -->
      <div class="qrcode-container">
        <img src="../assets/imgs/qrcode/yixi_zfb.png" style="width: 350px; height: 350px;" alt="支付宝支付二维码">
      </div>

      <div class="dialog-subtitle">打开支付宝[扫一扫]</div>
    </div>
  </div>
</template>

<script>
import requestApi from '@/service';
import configFields from '@/utils/configFields';
const { DEFAULT_NATION_CODE } = configFields;
export default {
  name: 'ArticlePay',
  data() {
    return {
      showPopup: false,
      zfbQRCodePopup: false,
      zfbQRCodeUrl: '',
      show_price: '',
      pay_type: 1, // 支付类型
      channel: '', // 支付平台
      order_num: '', // 订单编号
      order_price: '', // 订单价格
      order_status: 1, // 订单状态
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.prevPage = {
        path: from.path,
        query: from.query,
        params: from.params,
      };
      localStorage.loginPrevPage = JSON.stringify(vm.prevPage);
    });
  },
  activated() {
    Object.assign(this.$data, this.$options.data());
    this.initScrollTop();
    // 自动调用生成二维码方法
    // this.showWeChatQRCode();
  },
  beforeDestroy() {
  },
  computed: {
  },
  methods: {
    showWeChatQRCode() {
      // 校验输入数据

      // 初始化订单信息
      this.order_num = 'yixi_article_pay';
      this.order_price = 3.0;

      // 获取二维码 URL
      const qrUrl = 'https://yixi.tv/pay/wechat/yixi_article_pay';

      // 生成二维码
      QRCode.toDataURL(qrUrl, {
        type: 'image/jpeg',
        quality: 1,
        margin: 1,
      })
        .then(url => {
          this.zfbQRCodeUrl = url; // 设置二维码图片 URL
          this.zfbQRCodePopup = true; // 显示二维码弹窗
          console.log('generate qrcode success =========> ', url);
        })
        .catch(err => {
          console.error('generate qrcode error =========> ', err);
          this.$message.error('生成二维码失败，请稍后再试');
        });
    }
  },
};
</script>

<style lang="scss" scoped>
.login-page {
  height: calc(100vh - 160px);
  min-height: 600px;
  background: url('../assets/imgs/login-bg.jpg') no-repeat;
  background-position: center;
  background-size: cover;
  position: relative;

  .login-dialog {
    background: $C1;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 40px;
    width: 400px;
  }

  .dialog-title {
    font-family: HYXinRenWenSongW;
    font-size: 18px;
    color: $C3;
    text-align: center;
  }

  .dialog-subtitle {
    font-size: 14px;
    color: $C3;
    text-align: center;
  }

  // 添加二维码容器样式
  .qrcode-container {
    text-align: center;

    img {
      max-width: 100%;
      height: auto;
    }
  }
}
</style>